export default __webpack_public_path__ + "static/media/steps-ball-circled-blue.d6a76837.svg";